
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retelling/[pageNumber]",
      function () {
        return require("private-next-pages/retelling/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retelling/[pageNumber]"])
      });
    }
  